<template>
    <div class="lessonsMore">
        <div class="lesson-list flex-layout">
            <div class="p-pointer" v-for="(item,i) in lessonData.data" :key="i" @click="$router.push({path:'/home/lessons/study',query:{id:item.id,title:item.name}})">
                <LessonCard :data="item" />
            </div>
        </div>
        <div class="pagination" v-show="lessonData.data && lessonData.data.length>0">
            <el-pagination background @current-change="currentChange" :current-page="lessonData.current_page" :pager-count="5" layout="prev, pager, next" :total="lessonData.total" :page-size="15">
            </el-pagination>
        </div>
        <div class="lms-center" v-show="(!lessonData.data || lessonData.data.length==0)">
            <div>
                <img :src="require('@p/assets/images/courseempty.png')" alt="">
                <div style="text-align: center;">暫無課程</div>
            </div>
            <div>
                <div class=""></div>
            </div>
        </div>
    </div>
</template>

<script>
import LessonCard from '@p/components/lessonCard';
import { setTimeStr } from '@/utils';
export default {
    components:{ LessonCard },
    data(){
        return{
            loading:'',
            lessonData:{},
            categoryList: [],
            id:'',
        }
    },
    created() {
        if(this.$route.query) this.initDate(this.$route.query.page,15,this.$route.query.id);
    },
    watch:{
        '$route.query':function(v){
            this.initDate(v.page,15,v.id);
        },
    },
    mounted(){
        
    },
    methods:{
        // 获得课程
        initDate(page=1,take=15,id){
            this.loading=this.$loading({
                target:'.home-box-con'
            });
            if(this.$route.query.type == 1){ // 推荐
                this.$http.home.getHotCourse({params:{page,take}}).then(v=>{
                    if(v.status === 200){
                        this.lessonData=v.data.data;
                    }
                    this.loading.close();
                }).catch(v=>{})
            }else if(this.$route.query.type == 2){ //公开课
                this.$http.home.getDepartmentCourse({page,take}).then(v=>{
                    if(v.status === 200){
                        this.lessonData=v.data.data;
                    }
                    this.loading.close();
                }).catch(v=>{})
            }
        },
        currentChange(v) {
            // this.initDate(v,null,this.id)
            this.$router.replace({path:'/lessonsMore',query:{...this.$route.query,page:v}})
        },
        getTime(v){
            return setTimeStr(v)
        },
    }
}
</script>

<style lang="less" scoped>
.lessonsMore{
    margin-top: 40px;
    .pagination{
        display: flex;
        justify-content: center;
        margin-bottom: 40px;
    }
}
</style>